/**
 * Extract the file extension (uppercased, without the dot) from a filename.
 *
 * Examples:
 * - "document.pdf" -> "PDF"
 * - "archive.tar.gz" -> "GZ"
 * - "README" -> ""
 */
export const getFileExtension = (filename) => {
    const parts = filename.split(".");
    return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : "";
};
/**
 * Shorten a filename for UI display.
 *
 * - Keeps the extension (not returned; intended to be shown separately)
 * - Truncates the base name to 20 chars: 17 + "..."
 *
 * Examples:
 * - "very-long-filename-example.pdf" -> "very-long-filename-..."
 * - "report.pdf" -> "report"
 */
export const getShortFilename = (filename) => {
    const parts = filename.split(".");
    if (parts.length > 1) {
        parts.pop();
    }
    const nameWithoutExt = parts.join(".");
    return nameWithoutExt.length > 20
        ? `${nameWithoutExt.substring(0, 17)}...`
        : nameWithoutExt;
};
